import * as React from "react"
import type { SVGProps } from "react"
const SvgVerticalSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 21H4a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20q0-.42.29-.71A1 1 0 0 1 4 19h16q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 20 21m0-16H4a1 1 0 0 1-.71-.29A1 1 0 0 1 3 4q0-.42.29-.71A1 1 0 0 1 4 3h16q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 20 5m-7 7q0 .42-.29.71A1 1 0 0 1 12 13a1 1 0 0 1-.71-.29A1 1 0 0 1 11 12q0-.42.29-.71A1 1 0 0 1 12 11a.97.97 0 0 1 1 1m0 4q0 .42-.29.71A1 1 0 0 1 12 17a1 1 0 0 1-.71-.29A1 1 0 0 1 11 16q0-.42.29-.71A1 1 0 0 1 12 15a.97.97 0 0 1 1 1m0-8q0 .42-.29.71A1 1 0 0 1 12 9a1 1 0 0 1-.71-.29A1 1 0 0 1 11 8q0-.42.29-.71A1 1 0 0 1 12 7q.42 0 .71.29.3.29.29.71" />
  </svg>
)
export default SvgVerticalSpacing
